import type { LucideIcon } from "lucide-react"
import { useLocation } from "react-router-dom"
import { Link } from "~/components/Link"

import {
	SidebarGroup,
	SidebarGroupLabel,
	SidebarMenu,
	SidebarMenuBadge,
	SidebarMenuButton,
	SidebarMenuItem
} from "~/components/ui/sidebar"
import { cn } from "~/lib/utils"

export function NavMe({
	items
}: {
	items: {
		name: string
		slug: string
		icon?: LucideIcon
		badge?: number
		disabled?: boolean
	}[]
}) {
	const pathname = useLocation().pathname
	return (
		<SidebarGroup>
			<SidebarGroupLabel variant="section">Me</SidebarGroupLabel>
			<SidebarMenu>
				{items.map((item) => (
					<SidebarMenuItem
						key={item.name}
						className={cn(item.disabled && "cursor-not-allowed")}
						aria-disabled={item.disabled}
					>
						<SidebarMenuButton
							tooltip={item.name}
							asChild
							disabled={item.disabled}
							isActive={pathname === item.slug}
						>
							<Link
								to={item.slug}
								className="w-full"
								aria-disabled={item.disabled}
							>
								{item.icon && <item.icon className="size-4" />}
								<span className="grow">{item.name}</span>
								{item.badge && item.badge > 0 ? (
									<SidebarMenuBadge>
										{item.badge > 99 ? "99+" : item.badge}
									</SidebarMenuBadge>
								) : null}
							</Link>
						</SidebarMenuButton>
					</SidebarMenuItem>
				))}
			</SidebarMenu>
		</SidebarGroup>
	)
}
